import type { Cue } from "../../../model/manuals/lecture_video";

interface CueHighlight {
  seekButtonsByStartTime: Map<number, HTMLButtonElement>;
  activate: (currentTime: number, cues: readonly Cue[]) => void;
}

const createCueHighlight = (): CueHighlight => {
  const seekButtonsByStartTime = new Map<number, HTMLButtonElement>();
  let activeStart: number | null = null;

  const activate = (currentTime: number, cues: readonly Cue[]): void => {
    const nextStart =
      cues.find(
        (cue) => currentTime >= cue.startTime && currentTime < cue.endTime,
      )?.startTime ?? null;
    if (nextStart === activeStart) {
      return;
    }
    if (activeStart !== null) {
      seekButtonsByStartTime.get(activeStart)?.classList.remove("lecture_timeline_link-active");
    }
    if (nextStart !== null) {
      seekButtonsByStartTime.get(nextStart)?.classList.add("lecture_timeline_link-active");
    }
    activeStart = nextStart;
  };

  return { seekButtonsByStartTime, activate };
};

export { type CueHighlight, createCueHighlight };
